<div class="header-bar">
  <h1>Drivers</h1>
</div>
<div class="content-container">
  <div>
    <form (ngSubmit)="search()" style="width: 100%">
      <div class="ui-g filterPanel form-group">
        <div class="ui-g-12 ui-md-4 ui-lg-2">
          <span class="md-inputfield filterItem">
            <input
              name="firstName"
              type="text"
              pInputText
              [(ngModel)]="filterVal.filters.firstName.value"
            />
            <label>First Name</label>
          </span>
        </div>

        <div class="ui-g-12 ui-md-4 ui-lg-2">
          <span class="md-inputfield filterItem">
            <input
              name="surname"
              type="text"
              pInputText
              [(ngModel)]="filterVal.filters.surname.value"
            />
            <label>Surname</label>
          </span>
        </div>

        <div class="ui-g-12 ui-md-4 ui-lg-2">
          <span class="md-inputfield filterItem">
            <input
              name="nickName"
              type="text"
              pInputText
              [(ngModel)]="filterVal.filters.nickName.value"
            />
            <label>Nick Name</label>
          </span>
        </div>

        <div class="ui-g-12 ui-md-4 ui-lg-2">
          <span class="md-inputfield filterItem">
            <input
              name="mobileNumber"
              type="text"
              pInputText
              [(ngModel)]="filterVal.filters.mobileNumber.value"
            />
            <label>Mobile Number</label>
          </span>
        </div>

        <div class="ui-g-12">
          <button
            pButton
            class="btn-to-right"
            type="button"
            label="Clear"
            (click)="clearFilter(dt)"
          ></button>
          <button pButton class="btn-to-right" type="submit" label="Search"></button>
        </div>
      </div>
    </form>

    <p-table
      #dt
      sortField=""
      selectionMode="single"
      [value]="page.items"
      [lazy]="true"
      [rows]="10"
      [responsive]="true"
      [paginator]="true"
      rowHover="true"
      resizableColumns="true"
      [rowsPerPageOptions]="[5, 10, 20]"
      [pageLinks]="3"
      [totalRecords]="page.total"
      (onLazyLoad)="onGridLazyLoad($event)"
      (onRowSelect)="onRowSelect($event)"
      [(selection)]="selectedItem"
      [hidden]="!isLoaded"
    >
      <ng-template pTemplate="header">
        <tr>
          <th pSortableColumn="firstName">First Name</th>
          <th pSortableColumn="firstName">Surname</th>
          <th pSortableColumn="nickName">Nickname</th>
          <th pSortableColumn="mobileNumber">Mobile</th>
          <th>User Status</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-driver>
        <tr [pSelectableRow]="driver" (dblclick)="onRowDblclick(driver)">
          <td>{{ driver.firstName }}</td>
          <td>{{ driver.surname }}</td>
          <td>{{ driver.nickName }}</td>
          <td>{{ driver.mobileNumber }}</td>
          <td pEditableColumn="driver">
            <p-cellEditor>
              <ng-template pTemplate="output">
                <strong>{{ driver.isLockedOut ? 'Disabled' : 'Enabled' }}</strong>
              </ng-template>
              <ng-template pTemplate="input">
                <select
                  pInputText
                  [(ngModel)]="driver.isLockedOut"
                  (change)="lockUnlockUser(driver)"
                >
                  <option value="false">Enabled</option>
                  <option value="true">Disabled</option>
                </select>
              </ng-template>
            </p-cellEditor>
          </td>
        </tr>
      </ng-template>
    </p-table>

    <!-- DATATABLE DEPRECATED ---
    <p-dataTabl #dt sortField="" selectionMode="single" [value]="page.items" [lazy]="true" [rows]="10" [responsive]="true" [paginator]="true"
                 rowHover="true" resizableColumns="true" [rowsPerPageOptions]="[5,10,20]" [pageLinks]="3"
                 [totalRecords]="page.total" (onLazyLoad)="onGridLazyLoad($event)" (onRowSelect)="onRowSelect($event)" (onRowDblclick)="onRowDblclick($event)"
                 [(selection)]="selectedItem"
                 [hidden]="!isLoaded">
        <p-column *ngIf="uLevel && uLevel.organisationId" field="regionId" header="Region" [sortable]="false" [editable]="false">
            <ng-template let-driver="rowData" pTemplate="body">
                {{driver.depot.regionName}}
            </ng-template>
        </p-column>

        <p-column *ngIf="uLevel && (uLevel.organisationId || uLevel.supplierRegionId)" field="depotId" header="Depot" [sortable]="false" [editable]="false">
            <ng-template let-driver="rowData" pTemplate="body">
                {{driver.depot.name}}
            </ng-template>
        </p-column>

        <p-column field="firstName" header="First Name" [sortable]="tru" [editable]="false"></p-column>
        <p-column field="surname" header="Surname" [sortable]="tru" [editable]="false"></p-column>
        <p-column field="nickName" header="Nick Name" [sortable]="tru" [editable]="false"></p-column>
        <p-column field="mobileNumber" header="Mobile Number" [sortable]="tru" [editable]="false"></p-column>
        <p-column field="isLockedOut" header="User Status" [sortable]="tru" [editable]="false">
            <ng-template let-driver="rowData" pTemplate="body">
                {{ driver.isLockedOut ? 'Disabled': 'Enabled' }}
            </ng-template>
        </p-column>
    </p-dataTable>

    --->

    <div class="footerPanel ui-grid-row">
      <button
        *ngIf="backTo || isActiveCheckList"
        type="button"
        (click)="close()"
        class="btn-to-right"
        icon="fa ui-icon-close"
        pButton
        label="Close"
      ></button>
      <button
        *ngIf="orgType != 1"
        type="button"
        pButton
        (click)="goToImportData()"
        label="Import Data"
        icon="fa ui-icon-input"
        class="btn-to-right"
      ></button>
      <button
        type="button"
        pButton
        (click)="onEdit()"
        label="Edit"
        icon="fa ui-icon-mode-edit"
        class="btn-to-right"
        [disabled]="!selectedItem"
      ></button>

      <button
        *ngIf="orgType != 1"
        type="button"
        pButton
        (click)="lockUnlockUser(selectedItem)"
        [label]="selectedItem && selectedItem.isLockedOut ? 'Enable' : 'Disable'"
        [ngClass]="
          selectedItem && selectedItem.isLockedOut
            ? 'btn-to-right ui-button-success'
            : 'btn-to-right ui-button-danger'
        "
        [disabled]="!selectedItem"
      ></button>

      <button
        *ngIf="orgType != 1"
        type="button"
        pButton
        icon="fa ui-icon-add"
        (click)="AddDriver()"
        label="Add"
        class="btn-to-right"
      ></button>
    </div>
  </div>
</div>
<ng-template #loading>Loading...</ng-template>

<p-confirmDialog
  header="Confirmation"
  icon="fa-icon-circle"
  [style]="{ width: '425px' }"
  acceptLabel="Save"
  rejectLabel="Cancel"
></p-confirmDialog>
